/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { withRouter } from 'react-router';
import {
    QuestionFormBase,
    QuestionFormBaseProps,
    QuestionFormBaseState,
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';
import { MULTIMEDIA_TYPES, QTYPES, Region } from '@nexxt/common/types';
import { connect } from 'react-redux';
import NotifyHOC from '../../../../../../HOC/Notifications';

/* Components used in this question form. */
import BuilderHeader from '../../../common/builderHeader';
import QuestionSettings from '../../../common/questionSettings';
import SingleValue from '../../../../../common/reactSelect/SingleValue';
import IndicatorsContainer from '../../../../../common/reactSelect/IndicatorsContainer';
import Select from 'react-select';

/* Imports specifically for vector map question form. */
import { VectorMap } from '@nexxt-intelligence/react-jvectormap';
import { VECTOR_MAP_LIST } from '@nexxt/common/constants';
import './style.scss';
import MultimediaBubble from '../../../common/MultimediaBubble';

interface Props extends QuestionFormBaseProps {
    // nothing special... yet!
}

interface States extends QuestionFormBaseState {
    // nothing special... yet!
}

class VectorMapForm extends QuestionFormBase<Props, States> {
    /* Constructor just needs to specify this QTYPE! */
    constructor(p: QuestionFormBaseProps) {
        super(p, QTYPES.VECTOR_MAP);
        const { isNewQuestion } = this.props;
        const question = {
            ...this.state.question,
            showContinueButton: isNewQuestion
                ? true
                : this.state.question.showContinueButton
        };

        this.state = {
            ...this.state,
            question
        };
    }

    /* Here's where all the magic happens. */
    render() {
        const { currentProject } = this.props;
        const { question, isSettingBoxLayoutOpen } = this.state;
        const { selectedRegion } = question;
        const region = question.selectedRegion as Region;
        const questionError =
            (this.state.showError && this.state.questionError) || {};

        return (
            <div>
                <div className="project-add--question-builder">
                    <BuilderHeader
                        toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                        isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                        showAlert={!this.props.editEnabled}
                        alertMessages={this.getWarningMessage()}
                        question={question}
                        setValue={this.setQuestion}
                        disabled={!this.props.editEnabled}
                        errorObject={this.state.questionError}
                    />
                    <div className="builder-body">
                        {(isSettingBoxLayoutOpen && (
                            <QuestionSettings
                                onClose={this.toggleSettingBoxLayout}
                                question={question}
                                questionSettings={{
                                    allowUserEdit: true,
                                    showContinueButton: true,
                                    showNotApplicableOption: true
                                }}
                                setValue={this.setQuestion}
                                disabled={!this.props.editEnabled}
                            />
                        )) ||
                            null}
                        {this.renderErrorNotes()}
                        <MultimediaBubble
                            question={question}
                            languages={currentProject.languages}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            addNewBubble={this.NEW_addNewEditor}
                            removeBubble={this.NEW_removeEditor}
                            disabled={!this.props.editEnabled}
                            questionError={questionError}
                            settings={{ showClose: true }}
                        />

                        <div className="row">
                            <div className="col-md-12 form-group">
                                <label className="form-group__label form-group__label--block">
                                    Map of
                                </label>
                                <Select
                                    className={
                                        'form-select--react-select react-select'
                                    }
                                    // menuIsOpen={true}
                                    classNamePrefix="react-select"
                                    value={selectedRegion}
                                    options={VECTOR_MAP_LIST}
                                    onChange={(value) =>
                                        this.setQuestion(
                                            'selectedRegion',
                                            value
                                        )
                                    }
                                    col="col-md-12"
                                    components={{
                                        SingleValue,
                                        IndicatorsContainer
                                    }}
                                    isDisabled={!this.props.editEnabled}
                                />
                            </div>
                        </div>
                        <div className="vector-map-ui mb-4">
                            <VectorMap
                                key={(region && region.value) || 'ca_lcc'}
                                map={(region && region.value) || 'ca_lcc'}
                                backgroundColor="rgb(117, 181, 226)"
                                zoomOnScroll={false}
                                zoomButtons={false}
                                containerClassName="map ripple"
                            />
                        </div>

                        {(question.showNotApplicableOption && (
                            <MultimediaBubble
                                languages={currentProject.languages}
                                question={question}
                                setValue={this.setQuestion}
                                setValueWithLanguage={
                                    this.NEW_setQuestionTextTranslation
                                }
                                questionError={questionError}
                                keyName="notApplicableTexts"
                                disabled={!this.props.editEnabled}
                                disableAddBubble
                                defaultTextType={MULTIMEDIA_TYPES.TEXT}
                                questionText="Not Applicable text"
                                defaultText="BUTTON.NOT_APPLICABLE"
                                settings={{
                                    noBorder: true,
                                    useTranslation: true
                                }}
                            />
                        )) ||
                            null}

                        <MultimediaBubble
                            languages={currentProject.languages}
                            question={question}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            questionError={questionError}
                            keyName="continueTexts"
                            disabled={!this.props.editEnabled}
                            disableAddBubble
                            defaultTextType={MULTIMEDIA_TYPES.TEXT}
                            questionText="Continue button text"
                            defaultText="BUTTON.CONTINUE"
                            settings={{ noBorder: true, useTranslation: true }}
                        />
                    </div>
                    {/*end of builder body*/}
                </div>
            </div>
        );
    }
}

/* Component export wrapped in redux connector, wrapped in notify HOC */
export default withRouter(
    NotifyHOC(
        connect(
            mapStateToQuestionFormBaseProps,
            mapDispatchToQuestionFormBaseProps
        )(VectorMapForm)
    )
);
